export enum Entities {
  HOME = 'home',
  HOME_BANNER = 'home:banner',
  HOME_CLUB = 'home:club',
  HOME_KEEP_WATCHING = 'home:keepwatching',
  HOME_PURCHASES = 'home:purchases',
  HOME_COMMUNITY = 'home:community',
  HOME_COURSES = 'home:courses',
  HOME_OTHER_PRODUCTS = 'home:otherproducts',
  HOME_LIVE = 'home:live',
  PUBLIC_HOME_BANNER = 'home:public:banner',
  HEADER = 'header',
  LIBRARY = 'library',
  HEADER_MEMBERSHIP_MENU = 'header:membership:menu',
  HEADER_LANGUAGE_OPTIONS = 'header:languageoptions',
  HEADER_USER_MENU = 'header:user:menu',
  HEADER_SEARCH = 'header:search',
  HEADER_VIEW_AS = 'header:viewas',
  MODAL_SEARCH = 'modal:search',
  LIBRARY_PURCHASES = 'library:purchases',
  LIBRARY_COMBO = 'library:combo',
  LIBRARY_MODAL_COMBO = 'modal:library:combo',
  LIBRARY_ALL_PRODUCTS = 'library:allproducts',
  PAGE_ERROR = 'page:error',
  HOME_LOGGED = 'home:logged',
  LIBRARY_LOGGED = 'library:logged',
  HOME_PUBLIC = 'home:public',
  LIBRARY_PUBLIC = 'library:public',
  PRODUCTS_BUNDLE = 'products:bundle',
  UNBAN_MEMBER = 'community:user',
  LEGACY_CLUB_REDIRECT = 'home:legacyclubredirect',
  POST_SCHEDULED = 'post:scheduled',
  MODERATION = 'community:moderation',
  EXTERNAL_LINKS = 'menu:externallinks',
  COMMUNITY = 'community',
  BAN = 'ban',
  GROUP = 'group',
  MEMBERS_AND_PERMISSIONS = 'members_and_permissions',
  SCHEDULED_POST = 'scheduled_post',
  NOTIFICATIONS = 'notifications',
  SURVEY_COMMUNITY_DELETE = 'survey_community_delete',
  PRODUCT = 'product',
  CERTIFICATE = 'certificate_consumer',
  NOTIFICATIONS_CENTER = 'notifications_center'
}

export enum System {
  MEMBERSHIP_CONSUMER = 'mem_consumer_activation',
  CONSUMER_ENGAGEMENT = 'consumer_engagement'
}

export enum Mode {
  PRODUCTION = 'production',
  STAGING = 'staging'
}

export enum Actions {
  CLICK_TRY_AGAIN = 'click:tryagain',
  CLICK_PRODUCT = 'click:product',
  CLICK_PRODUCT_FREE_SIGNUP = 'click:product:freesignup',
  CLICK_PRODUCT_PRODUCT_PAGE = 'click:product:productpage',
  CLICK_PRODUCT_URL = 'click:product:url',
  CLICK_ALL_PRODUCTS = 'click:allproducts',
  CLICK_BANNER = 'click:banner',
  CLICK_COMMUNITY = 'click:community',
  CLICK_LOGO = 'click:logo',
  CLICK_MENU = 'click:menu',
  CLICK_MENU_BEGIN = 'click:menu:begin',
  CLICK_MENU_LIBRARY = 'click:menu:library',
  CLICK_MENU_COMMUNITY = 'click:menu:community',
  CLICK_EN_LANGUAGE_OPTIONS = 'click:languageoptions:en',
  CLICK_ES_LANGUAGE_OPTIONS = 'click:languageoptions:es',
  CLICK_PTBR_LANGUAGE_OPTIONS = 'click:languageoptions:ptbr',
  CLICK_FR_LANGUAGE_OPTIONS = 'click:languageoptions:fr',
  CLICK_IT_LANGUAGE_OPTIONS = 'click:languageoptions:it',
  CLICK_JA_LANGUAGE_OPTIONS = 'click:languageoptions:ja',
  CLICK_DE_LANGUAGE_OPTIONS = 'click:languageoptions:de',
  CLICK_PROFILE = 'click:profile',
  CLICK_THEME = 'click:theme',
  CLICK_PURCHASES = 'click:purchases',
  CLICK_HELP = 'click:help',
  CLICK_LOGOUT = 'click:logout',
  CLICK_SIGNIN = 'click:signin',
  CLICK_SIGNUP = 'click:signup',
  CLICK_MENU_HELP = 'click:menu:help',
  CLICK_MENU_MY_PURCHASES = 'click:menu:mypurchases',
  CLICK_ACTIVATE_SEARCH = 'click:activate:search',
  CLICK_EXECUTE_SEARCH = 'click:execute:search',
  CLICK_EXIT_SEARCH = 'click:exit:search',
  CLICK_VIEW_AS_SETTINGS = 'click:viewas:settings',
  CLICK_CREATOR_VIEW_AS_ROLE_OPTIONS = 'click:viewas:roleoptions:creator',
  CLICK_MEMBER_VIEW_AS_ROLE_OPTIONS = 'click:viewas:roleoptions:member',
  CLICK_USER_WITHOUT_ACCESS_VIEW_AS_ROLE_OPTIONS = 'click:viewas:roleoptions:userwithoutaccess',
  CLICK_LOGGED_OUT_USER_VIEW_AS_ROLE_OPTIONS = 'click:viewas:roleoptions:loggedoutuser',
  CLICK_LIVE_CARD = 'click:live:card',
  CLICK_VIEW_AS_CLASS = 'click:viewas:class',
  CLICK_NOTIFICATIONS_ICON = 'click:notifications:icon',
  CLICK_NOTIFICATIONS_READ_ALL = 'click:notifications:readall',
  CLICK_NOTIFICATION_LIKE = 'click:notification:like',
  CLICK_NOTIFICATION_COMMENT = 'click:notification:comment',
  CLICK_NOTIFICATION_DRIPPING = 'click:notification:dripping',
  CLICK_NOTIFICATION_REPLY = 'click:notification:reply',
  CLICK_LINKEDIN_BUTTON = 'click:toshareon:linkedin',
  CLICK_FACEBOOK_BUTTON = 'click:toshareon:facebook',
  CLICK_WHATSAPP_BUTTON = 'click:toshareon:whatsapp',
  CLICK_X_BUTTON = 'click:toshareon:x',
  CLICK_RETURN_BUTTON = 'click:return:button',
  CLICK_DOWNLOAD_CERTIFICATE = 'click:todownloadcertificate',
  CLICK_COPY_CERTIFICATE_LINK = 'click:tocopycertificate:link',
  HOME_PUBLIC_VIEW_PAGE = 'home:public:viewpage',
  HOME_PUBLIC_PAGE_ERROR = 'home:public:pageerror',
  LIBRARY_PUBLIC_VIEW_PAGE = 'library:public:viewpage',
  LIBRARY_PAGE_ERROR = 'library:pagerror',
  SEARCH_ERROR = 'search:error',
  SEARCH_EMPTY = 'search:empty',
  SEARCH_LOADING_TIME = 'search:loading:time',
  CLICK_SEARCH_RESULT = 'click:search:result',
  VIEW_SEARCH_RESULT = 'view:search:result',
  CLICK_COMBO = 'click:combo',
  CLICK_BUY = 'click:buy',
  CLICK_EXIT = 'click:exit',
  CLICK_NOT_FOUND_BACK = 'click:notfound:goback',
  CLICK_TRY_AGAIN_CONNECTION = 'click:tryagain:connectionlost',
  CLICK_ITEM_SEARCH_MODAL = 'click:item:search:modal',
  PAGEVIEW = 'pageview',
  VIEW_HOME = 'view:home',
  VIEW_LIBRARY = 'view:library',
  VIEW_CLUB_ONBOARDING = 'view:club:onboarding',
  CLICK_ONBOARDING_ONE = 'click:onboarding:one',
  CLICK_ONBOARDING_TWO = 'click:onboarding:two',
  CLICK_ONBOARDING_THREE = 'click:onboarding:three',
  CLICK_ONBOARDING_COMMUNITY = 'click:onboarding:community',
  CLICK_ONBOARDING_CLOSE = 'click:onboarding:close',
  COMMUNITY_ADD = 'community:add',
  COMMUNITY_EDIT = 'community:edit',
  COMMUNITY_DELETE = 'community:delete',
  COMMUNITY_VIEW = 'community:view',
  COMMUNITY_GROUP_ADD = 'add',
  COMMUNITY_GROUP_CREATE = 'create',
  COMMUNITY_GROUP_EDIT = 'edit',
  COMMUNITY_GROUP_DELETE = 'delete',
  COMMUNITY_GROUP_SAVE_EDIT = 'save:edit',
  COMMUNITY_EMPTY = 'community:empty',
  COMMUNITY_UNBAN_MEMBER = 'unban',
  OPEN = 'open',
  SAVE = 'save',
  PUBLISH = 'publish',
  DELETE = 'delete',
  CREATE = 'create',
  BIND = 'bind',
  SETUP = 'setup',
  VIEW = 'view',
  CLICK_REDIRECT_USER = 'click:redirectuser',
  AUTOMATIC_REDIRECT_USER = 'automatic:redirectuser',
  CLICK_ADD = 'click:add',
  CLICK_EDIT = 'click:edit',
  CLICK_REMOVE = 'click:remove',
  ADD_SUCCESS = 'add:success',
  EDIT_SUCCESS = 'edit:success',
  REMOVE_SUCCESS = 'remove:success',
  UPDATE_PERMISSION = 'update_permission',
  UNBLOCK = 'unblock',
  CLICK_MODULE = 'click:module',
  ANSWER = 'answer',
  CLICK_MY_ACCOUNT = 'click:myaccount',
  VIEW_CERTIFICATE_LOGGED = 'view:certificate:loggedpage',
  VIEW_CERTIFICATE_HOTMART = 'view:certificate:unloggedpagehotmart',
  VIEW_CERTIFICATE_CLUB = 'view:certificate:unloggedpageclub',
  CLICK_NOTIFICATIONS_CENTER_OPEN_MENU = 'click:notifications_center:open_menu',
  CLICK_NOTIFICATIONS_CENTER_ACTIVITIE_ITEM = 'click:notifications_center:activitie:item',
  CLICK_NOTIFICATIONS_CENTER_PRODUCT_ITEM = 'click:notifications_center:product:item',
  CLICK_NOTIFICATIONS_CENTER_PRODUCT_READ_ALL = 'click:notifications_center:product:read_all',
  CLICK_NOTIFICATIONS_CENTER_ACTIVITIE_READ_ALL = 'click:notifications_center:activitie:read_all'
}

export enum SearchTypes {
  COMMUNITY = 'COMMUNITY',
  TOPICS = 'TOPICS',
  MODULES = 'MODULES',
  CLASSES = 'CLASSES',
  PRODUCTS = 'PRODUCTS'
}

export enum EventNames {
  CLICK_TO_BUY_A_PRODUCT = 'click to buy a product',
  SELECT_COMMUNITY_TYPE = 'select community type',
  TRY_CREATE_COMMUNITY = 'try to create community',
  BIND_A_PRODUCT_TO_COMMUNITY = 'click to bind a product to the community',
  UNBIND_A_PRODUCT_TO_COMMUNITY = 'click to unbind a product to the community',
  CONFIRM_UNBIND_A_PRODUCT_TO_COMMUNITY = 'click to confirm the unbind of the product from the community',
  TRY_TO_SAVE_PRODUCT_BIND_CHANGES = 'try to save product bind changes',
  TRY_TO_SAVE_PRODUCT_UNBIND_CHANGES = 'try to save product unbind changes',
  SETUP_COMMUNITY = 'click to setup community',
  GO_TO_PRIVACY_AND_ACCESS = 'click to go to privacy and access',
  GO_TO_GENERAL_CONFIG = 'click to go to general config',
  CREATE_COMMUNITY = 'click to create a community',
  SEE_MORE_PRODUCTS_ACCESS_AND_PRIVACY = 'click to see more product to bind',
  VIEW_COMMUNITY_FEED = 'click to view community feed',
  CLOSE_COMMUNITY_CREATE_MODAL = 'close community creation modal',
  COMMUNITY_CONFIG_MEMBERS_PERMISSIONS = 'to go to members and permissions',
  COMMUNITY_CONFIG_CHANGE_PERMISSION_MODERATOR = 'to change user permission to moderator',
  COMMUNITY_CONFIG_CHANGE_PERMISSION_MEMBER = 'to change user permission to member',
  COMMUNITY_CONFIG_BLOCK_LIST = 'click to go to block list',
  COMMUNITY_CONFIG_BLOCK_USER = 'to block a user',
  COMMUNITY_CONFIG_UNBLOCK_USER = 'try to unblock a user',
  COMMUNITY_FEED = 'community feed',
  COMMUNITY_SETUP = 'to setup community',
  COMMUNITY_TYPE = 'community type',
  COMMUNITY_VIEW_INFO = 'to view community info',
  COMMUNITY_VIEW_FEED = 'to view community feed',
  CREATE_GROUP = 'try to create group',
  DELETE_COMMUNITY = 'try to delete community',
  DELETE_GROUP = 'try to delete group',
  POST_SCHEDULE = 'to schedule a post',
  POST_SCHEDULED_LIST = 'to go to scheduled posts',
  POST_SCHEDULE_DELETE = 'to delete schedule a post',
  POST_SCHEDULED_POST = 'to post a scheduled post',
  POST_START = 'to start a post',
  GO_TO_MEMBERS_AND_PERMISSIONS = 'click to go to members and permissions',
  COMMUNITY_CHANGE_USER_PERMISSION = 'try to change user permission',
  CLICK_TO_LIMIT_PUBLICATION = 'click to limit publication',
  CLICK_TO_ACCESS_MY_PURCHASE = 'click to access my purchase',
  COMMUNITY_DELETE_SURVEY = 'community delete survey'
}

export enum ScreenNames {
  COMMUNITY_CREATE_VIEW = 'CommunityCreateView',
  COMMUNITY_EDIT_VIEW = 'CommunityEditView',
  COMMUNITY_VIEW = 'CommunityView',
  BAN_VIEW = 'BanView',
  UNBAN_VIEW = 'UnBanView',
  OTHERS = 'others',
  COMMUNITY_CREATION_MODAL = 'community-creation-modal',
  HOME_MEMBERSHIP_CONSUMER = 'home-membership-consumer',
  COMMUNITY_FEED = 'community-feed',
  COMMUNITY_POST_DETAIL = 'community-post-detail',
  PRODUCT_LIST_MEMBERSHIP_CONSUMER = 'product-list-membership-consumer',
  COMMUNITY_CONFIGURATION_MODAL_ACCESS_AND_PRIVACY = 'community-configuration-modal/access-and-privacy',
  COMMUNITY_CONFIGURATION_MODAL_GENERAL_CONFIG = 'community-configuration-modal/general-config'
}

export enum RequestResults {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export enum ProductConsumeType {
  PREMIUM = 'PREMIUM',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  PAID = 'PAID'
}

export enum ComponentNames {
  SIDE_MENU = 'SIDE-MENU',
  PRODUCTS = 'PRODUCTS',
  SIDE_DROPDOWN = 'SIDE-DROPDOWN',
  CONFIGURATION_MODAL = 'CONFIGURATION-MODAL',
  COMMUNITY_LIST = 'COMMUNITY-LIST',
  FLOATING_BUTTON = 'FLOATING-BUTTON',
  MEMBERSHIP_HOME = 'MEMBERSHIP-HOME',
  COMMUNITY_SETTINGS = 'COMMUNITY-SETTINGS',
  EDIT_MENU_CONFIG = 'EDIT-MENU-CONFIG',
  COMMUNITY_CREATION_MODAL = 'COMMUNITY-CREATION-MODAL',
  CHANGE_COMMUNITY_TYPE_MODAL = 'CHANGE-COMMUNITY-TYPE-MODAL',
  SIDEBAR_MODERATION = 'SIDEBAR-MODERATION',
  ACCESS_AND_PRIVACY_TAB = 'ACCESS-AND-PRIVACY-TAB'
}

export enum showcaseOrientation {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL'
}

export const CommunityTypeProductConsume = {
  1: ProductConsumeType.PUBLIC,
  2: ProductConsumeType.PRIVATE,
  3: ProductConsumeType.PREMIUM,
  4: ProductConsumeType.PAID
}

export const SourceNames = {
  productListSuggestionModal: 'PRODUCT-LIST-SUGGESTION-MODAL',
  onboardingClubAdmin: 'ONBOARDING-CLUB-ADMIN'
}

export enum SurveyNames {
  DELETE_COMMUNITY = 'Comunidade deletada'
}

export enum PwaDetails {
  ENABLE = ' - PWA',
  DISABLE = '',
  DISPLAY_MODE_STANDALONE = '(display-mode: standalone)',
  MANIFEST_ATTRIBUTE = "link[rel='manifest']"
}

export enum FailureDescription {
  NOT_FAILURE_RESULT_EVENT = 'NOT_FAILURE_RESULT_EVENT',
  NO_MESSAGE = 'NO_MESSAGE'
}

export enum Visibility {
  VISIBLE = 'VISIBLE',
  HIDDEN = 'HIDDEN'
}

export enum IsActivedValue {
  YES = 'YES',
  NO = 'NO'
}

export enum TryResult {
  SUCCESSFUL = 'SUCCESSFUL',
  FAILURE = 'FAILURE'
}

export enum ComponentSource {
  DEFAULT_SOURCE = 'DEFAULT-SOURCE'
}
